import {apolloStore as apollo} from '@stores';
import {LOOKUP_SHORTENED_URL, SHORTEN_URL} from './';
import {action} from '@api';

export class ShortenerStore {
  @action shorten = async (url: string) => {
    const {data: {shorten}} = await apollo.client.mutate<{shorten: string}>(
      {
        mutation: SHORTEN_URL,
        variables: { longUrl: url }
      }
    )

    return shorten
  }
  @action lookupLongUrl = async (shortUrl: string) => {
    const { data: {redirect }} = await apollo.client.query<{ redirect: string }>(
      {
        query:     LOOKUP_SHORTENED_URL,
        variables: {shortUrl}
      }
    )
    return redirect
  }
}

export const shortener = new ShortenerStore()


// WEBPACK FOOTER //
// ./src/modules/common/graphql/shortener/ShortenerStore.ts